module.exports = __webpack_public_path__ + "static/img/brand-second-1-new.e7078a00.png";